module.exports = __webpack_public_path__ + "static/media/car-3.129d31de.jpg";